import { useCallback } from 'react';

import type { PaymentOption } from '@src/features/payments';

import { useCheckoutTracking } from './useCheckoutTracking';

/**
 * The buyer's own pick of a payment method. The step opens on a preselected method (Pix sorts
 * first), which is not a choice and stays out of payment_method_selected; the method a purchase
 * was paid with travels on checkout_completed. Each event is therefore a click on a method other
 * than the one on screen, which is what counts how often the buyer switches.
 */
export const useCheckoutMethodSelect = (
  selected: PaymentOption | undefined,
  select: (option: PaymentOption) => void,
) => {
  const tracking = useCheckoutTracking();
  const selectedId = selected?.paymentMethod.id;

  return useCallback(
    (option: PaymentOption) => {
      if (option.paymentMethod.id !== selectedId) {
        tracking.paymentMethodSelected(option.paymentMethod.code);
      }

      select(option);
    },
    [selectedId, select, tracking],
  );
};

export default useCheckoutMethodSelect;
